import * as types from '../mutation-types'
import { BASE_DATA_MANAGER } from '../../data'
import { API } from '../../api';

export default {
    namespaced: true,
    state: {
        gotSituationData: false,
        situationList: [],
        gotStrongData: false,
        strongList: [],
        gotMedicineData: false,
        medicineList: [],
        gotTypeData: false,
        typeList: []
    },
    getters: {},
    mutations: {
        [types.BASE_INIT_SITUATION_DATA](state, data) {
            if(state.gotSituationData) { return; }
            state.gotSituationData = true;
            state.situationList = BASE_DATA_MANAGER.getBaseListDataByData('situation', data);
            console.log('types.BASE_INIT_SITUATION_DATA----', data, state.situationList)
        },
        [types.BASE_ADD_SITUATION](state, params) {
            API.addSituation({
                f_name: params.text
            }, function(data){
                var newData = {
                    id: data.id,
                    text: data.f_name,
                    type: 'situation'
                }
                state.situationList = [newData].concat(state.situationList);
                console.log('自定义命局成功::::::', data, state.situationList);
                if(params.cb && typeof(params.cb) == 'function') {
                    setTimeout(() => {
                        params.cb(newData);
                    }, 10);
                }
            })
        },
        [types.BASE_UPDATE_SITUATION](state, situationId) {
            console.log('types.BASE_UPDATE_SITUATION-----', situationId)
        },
        [types.BASE_DELETE_SITUATION](state, situationId) {
            console.log('types.BASE_DELETE_SITUATION-----', situationId)
        },
        [types.BASE_INIT_STRONG_DATA](state, data) {
            if(state.gotStrongData) { return; }
            state.gotStrongData = true;
            state.strongList = BASE_DATA_MANAGER.getBaseListDataByData('strong', data);
            console.log('types.BASE_INIT_STRONG_DATA----', data, state.strongList)
        },
        [types.BASE_ADD_STRONG](state, params) {
            API.addStrong({
                f_name: params.text
            }, function(data) {
                var newData = {
                    id: data.id,
                    text: data.f_name,
                    type: 'strong'
                }
                state.strongList = [newData].concat(state.strongList);
                console.log('自定义强弱成功::::::', data, state.strongList)
                if(params.cb && typeof(params.cb) == 'function') {
                    setTimeout(() => {
                        params.cb(newData);
                    }, 10);
                }
            })
        },
        [types.BASE_UPDATE_STRONG](state, strongId) {
            console.log('types.BASE_UPDATE_STRONG-----', strongId)
        },
        [types.BASE_DELETE_STRONG](state, strongId) {
            console.log('types.BASE_DELETE_STRONG-----', strongId)
        },
        [types.BASE_INIT_MEDICINE_DATA](state, data) {
            if(state.gotMedicineData) { return; }
            state.gotMedicineData = true;
            state.medicineList = BASE_DATA_MANAGER.getBaseListDataByData('medicine', data);
            console.log('types.BASE_INIT_MEDICINE_DATA----', data, state.medicineList)
        },
        [types.BASE_ADD_MEDICINE](state, params) {
            console.log('types.BASE_ADD_MEDICINE-----', params)
            API.addMedicine({
                f_name: params.text
            }, function(data){
                var newData = {
                    id: data.id,
                    text: data.f_name,
                    type: 'medicine'
                }
                state.medicineList = [newData].concat(state.medicineList);
                console.log('自定义药成功::::::', data, state.medicineList)
                if(params.cb && typeof(params.cb) == 'function') {
                    setTimeout(() => {
                        params.cb(newData);
                    }, 10);
                }
            })
        },
        [types.BASE_UPDATE_MEDICINE](state, medicineId) {
            console.log('types.BASE_UPDATE_MEDICINE-----', medicineId)
        },
        [types.BASE_DELETE_MEDICINE](state, medicineId) {
            console.log('types.BASE_DELETE_MEDICINE-----', medicineId)
        },
        [types.BASE_INIT_TYPE_DATA](state, data) {
            if(state.gotTypeData) { return; }
            state.gotTypeData = true;
            state.typeList = data;
            console.log('types.BASE_INIT_TYPE_DATA----', data, state.typeList);
        }
    },
    actions: {
        initSituationData({ commit }, data) {
            commit(types.BASE_INIT_SITUATION_DATA, data)
        },
        addSituation({ commit }, params) {
            commit(types.BASE_ADD_SITUATION, params)
        },
        updateSituation({ commit }, situationId) {
            commit(types.BASE_UPDATE_SITUATION, situationId)
        },
        deleteSituation({ commit }, situationId) {
            commit(types.BASE_DELETE_SITUATION, situationId)
        },
        initStrongData({ commit }, data) {
            commit(types.BASE_INIT_STRONG_DATA, data)
        },
        addStrong({ commit }, params) {
            commit(types.BASE_ADD_STRONG, params)
        },
        updateStrong({ commit }, strongId) {
            commit(types.BASE_UPDATE_STRONG, strongId)
        },
        deleteStrong({ commit }, strongId) {
            commit(types.BASE_DELETE_STRONG, strongId)
        },
        initMedicineData({ commit }, data) {
            commit(types.BASE_INIT_MEDICINE_DATA, data)
        },
        addMedicine({ commit }, params) {
            commit(types.BASE_ADD_MEDICINE, params)
        },
        updateMedicine({ commit }, medicineId) {
            commit(types.BASE_UPDATE_MEDICINE, medicineId)
        },
        deleteMedicine({ commit }, medicineId) {
            commit(types.BASE_DELETE_MEDICINE, medicineId)
        },
        initTypeData({ commit }, data) {
            commit(types.BASE_INIT_TYPE_DATA, data)
        }
    }
}